<template>
	<div class="title-container width-100 flex-column">
		<div class="width-100 display-flex flex-row flex-align-center pa-4 pl-2 mb-2">Page options</div>
		<v-expansion-panels flat accordion>
			<ExpansionPanel class="pl-2 pr-7" title="Layout">
				<WidgetLayoutSettingsPanel />
			</ExpansionPanel>
			<div class="section-container width-100 display-flex flex-column">
				<SettingSwitch title="Interface title" :switchValue.sync="isTitleEnabled" />
				<div class="setting-title mt-3 px-2" v-if="widgetTitle.active === 1">
					Edit title
					<SettingSwitch noSwitch title="Edit title" :textFieldValue.sync="titleValue" :placeholder="'Type your title here'" />
				</div>
			</div>
			<ExpansionPanel class="pl-2 pr-7" title="Feature appearance">
				<div class="feature-appearance-description">Customize background, icon and progress bar for all interfaces</div>
				<div class="width-100 display-flex flex-row flex-justify-end">
					<AnemicButton @click="openFeatureAppearanceSettingsDialog" class="edit-button mt-1">Edit</AnemicButton>
				</div>
			</ExpansionPanel>
		</v-expansion-panels>
	</div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import { editNode } from '@/store/modules/selectedNode/getters';
import { widgetMetadata } from '@/store/modules/widgetEditor/getters';
import { setWidgetTitle } from '@/store/modules/widgetEditor/actions';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import WidgetLayoutSettingsPanel from '@/components/BlockEditorWidget/FieldSettings/PageOptions/WidgetLayoutSettingsPanel';
export default {
	name: 'WidgetPageOptions',
	components: {
		ExpansionPanel,
		SettingSwitch,
		WidgetLayoutSettingsPanel,
	},
	computed: {
		...mapGetters([widgetMetadata.fullPath, editNode.fullPath]),
		widgetOptions() {
			return this[widgetMetadata.fullPath]?.options || {};
		},
		widgetTitle() {
			return this[widgetMetadata.fullPath].options.title || {};
		},
		titleValue: {
			set(value) {
				const oldTitleOption = cloneDeep(this.widgetOptions.title || {});
				if (
					!this[editNode.fullPath]?.node_title ||
					this.widgetTitle === this[editNode.fullPath]?.node_title ||
					oldTitleOption.value === this[editNode.fullPath]?.node_title
				) {
					this.setParamInEditNode({ key: 'node_title', value });
				}

				oldTitleOption.value = value;
				this[setWidgetTitle.fullPath](value);
				this.setWidgetOption({ key: 'title', value: oldTitleOption });
			},
			get() {
				return this.widgetOptions.title.value || '';
			},
		},
		isTitleEnabled: {
			set(value) {
				this.changeWidgetTitleState(value ? 1 : 0);
			},
			get() {
				return this.widgetTitle.active === 1;
			},
		},
	},
	methods: {
		...mapActions([setWidgetTitle.fullPath]),
		...mapActions('widgetEditor', ['setWidgetOption']),
		...mapActions('selectedNode', ['setParamInEditNode']),
		changeWidgetTitleState(active = 0) {
			const newTitleValue = { ...this.widgetTitle, active };
			this.setWidgetOption({ key: 'title', value: newTitleValue });
		},
		async openFeatureAppearanceSettingsDialog() {
			await AppDialogManagerService.openFeatureAppearanceSettingsDialog();
		},
	},
	data: () => ({
		localField: {
			metadata: {
				options: { title: {}, longText: {}, description: {}, required: {}, placeholder: {}, helper_text: {}, prefill: {} },
				style: { background: {}, outline: {} },
			},
		},
	}),
};
</script>
<style scoped lang="scss">
.setting-title {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}
.title-container {
	height: 55px;
	font-size: 16px;
	font-weight: bold;
	background: transparent;
	color: var(--primary-font-color);
	border-bottom: 1px solid var(--border-color);
}
.section-container {
	padding: 14px 10px 14px 8px;
	border-bottom: 1px solid var(--border-color);
}
.feature-appearance-description {
	font-weight: normal;
	font-size: 11px;
	color: var(--description-text);
}

.edit-button {
	padding: 0px;
	width: 80px !important;
	height: 25px !important;
	font-size: 12px !important;
	border-radius: 8px !important;
	background: var(--bg-color) !important;
	color: var(--primary-color) !important;
	border: 1px solid var(--primary-color) !important;
}
</style>
